import { createContext, PropsWithChildren, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useOperationTranslation from "../hooks/useOperationTranslation";
import OperationTypes from "../types";
import MasterdataSupplierService from "../service/MasterdataSupplierService";
import EnumChangeName from "../component/common/EnumChangeName";
import UserLocationType from "../types/UserLocationType";

interface IContextOperation {
  loading: boolean;
  vehicleEntranceTab: number;
  setLoading: (val: boolean) => void;
  setVehicleEntranceTab: (val: number) => void;
  tenant: string;
  setTenant: (val: string) => void;
  userLocations: OperationTypes.UserLocation[];
  allLocations: OperationTypes.Domain[];
  locationsLoading: boolean;
}

export const ContextOperation = createContext<IContextOperation>({
  loading: false,
  vehicleEntranceTab: 0,
  setLoading: () => {},
  setVehicleEntranceTab: () => {},
  tenant: "",
  setTenant: (val: string) => {},
  userLocations: [],
  allLocations: [],
  locationsLoading: false,
});

export const ProviderOperation = (props: PropsWithChildren<any>) => {
  const { i18n } = useTranslation();
  const t = useOperationTranslation();
  const enumName = EnumChangeName();

  const [loading, setLoading] = useState(false);
  const [vehicleEntranceTab, setVehicleEntranceTab] = useState<number>(0);

  const user: any = JSON.parse(localStorage.getItem("user") || "");
  const [tenant, setTenant] = useState(user?.legalEntities?.find((ten: any) => ten.name !== "all").name || "");

  const [allLocations, setAllLocations] = useState<OperationTypes.Domain[]>([]);
  const [userLocations, setUserLocations] = useState<OperationTypes.UserLocation[]>([]);

  const [locationsLoading, setLocationsLoading] = useState(false);
  useEffect(() => {
    setLocationsLoading(true);
    const allLocations: UserLocationType[] = [];
    user.mobilityStores?.map((ms: any) => {
      if (ms.id !== 0) {
        allLocations.push({
          name: `${ms.name} (${t("vehicleExit.locationType.lms")})`,
          type: `${t("vehicleExit.locationType.lms")}`,
          bpCode: ms.bpCode,
          sapId: ms.sapId,
          tenant: ms.tenant,
          typeEnum: "LMS",
          key: `${ms.bpCode}-LMS`,
          zoneid: ms.zoneId,
        });
      }
    });
    user.logisticCompounds?.map((lc: any) => {
      //console.log("lc", lc)
      if (lc.id !== 0) {
        allLocations.push({
          name: `${lc.name} (${t("vehicleExit.locationType.compound")})`,
          type: `${t("vehicleExit.locationType.compound")}`,
          bpCode: lc.bpCode,
          sapId: lc.bpCode,
          tenant: lc.tenant,
          typeEnum: "COMPOUND",
          key: `${lc.bpCode}-COMPOUND`,
          //zoneid: lc.zoneId, // FIXME: Missing zoneId
        });
      }
    });

    const filteredAllLocations = allLocations.filter(
      (loc) => loc.tenant === tenant
    );
    
    const usrLocations = filteredAllLocations?.map((loc: UserLocationType) => {
      return {
        name: loc.name,
        label: loc.name,
        descr: loc.name,
        value: loc.bpCode ? loc.bpCode : loc.sapId,
        bpCode: loc.bpCode ? loc.bpCode : loc.sapId,
        sapId: loc.bpCode ? loc.bpCode : loc.sapId,
        id: loc.bpCode ? loc.bpCode : loc.sapId,
        type: loc.type,
        tenant: loc.tenant,
        typeEnum: loc.typeEnum,
        key: `${loc.bpCode}-${loc.typeEnum}`,
        zoneid: loc.zoneid,
      };
    });
    
    setUserLocations(usrLocations.sort((a,b) => a.name!.toLowerCase() > b.name!.toLowerCase() ? 1 : -1));
    setLocationsLoading(false);
  }, [i18n?.language, tenant]);

  useEffect(() => {
    MasterdataSupplierService.get.allLocations(tenant, 0, 100000).then(
      (response) => {
        setAllLocations(response.map((element: OperationTypes.Domain) => ({
          ...element,
          description: `${element.locationEntityDesc} (${enumName.locationType(element.type).toUpperCase()})`,
          bpCode: element.bpCode,
          type: element.type,
          typeEnum: element.type.toUpperCase(),
          key: `${element.bpCode}-${element.type.toUpperCase()}`,
          zoneid: element.zoneid, // TODO: Maybe change to "zoneId"
        })));
      }
    )
  }, [tenant]);

  return (
    <ContextOperation.Provider
      value={{
        loading,
        vehicleEntranceTab,
        setLoading,
        setVehicleEntranceTab,
        tenant,
        setTenant,
        userLocations,
        allLocations,
        locationsLoading,
      }}
    >
      {props.children}
    </ContextOperation.Provider>
  );
};
